<template>
      <el-dialog
      :title="'Đặt biệt danh cho ' + conversation.toName"
      width="400px"
      :visible.sync="showPopOverSwName"
      destroy-on-close>
      <div>
        <el-input
          placeholder="Nhập biệt danh"
          type="textarea"
          :rows="3"
          v-model="conversation.swName"
          @keydown.enter.exact.native="saveSwName"
          resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="saveSwName()">
            Lưu
          </el-button>
        </div>
      </div>
    </el-dialog>

</template>

<script>
export default {
  name: "DialogChangeSwName",
  components: {},
  props: ["conversation", "showPopOverSwName"],
  data() {
    return {
      swName: '',
    }
  },
  methods: {
    saveSwName() {
      this.$http.get("/api/conversation/setSwName", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          swName: this.conversation.swName,
        },
      });
      this.alert("success", 'Cập nhật thành công!');
      this.$emit('updated')
    }
  },
  mounted() {
    this.swName = this.conversation?.swName || ''
  }
}
</script>

<style>

</style>